/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaginatedShowListList,
  PatchedShow,
  PatchedShowCreateUpdate,
  Show,
  ShowCreateUpdate,
} from '../models/index';
import {
    PaginatedShowListListFromJSON,
    PaginatedShowListListToJSON,
    PatchedShowFromJSON,
    PatchedShowToJSON,
    PatchedShowCreateUpdateFromJSON,
    PatchedShowCreateUpdateToJSON,
    ShowFromJSON,
    ShowToJSON,
    ShowCreateUpdateFromJSON,
    ShowCreateUpdateToJSON,
} from '../models/index';

export interface ShowsAddPerformerRequest {
    id: string;
    show: Omit<Show, 'id'|'attendance'|'ticket_revenue'|'bar_revenue'|'other_revenue'|'total_expenses'|'total_revenue'|'net_profit'|'is_settled'|'settlement_date'|'team_name'|'created_by'|'created_at'|'updated_at'|'show_stages'|'show_performers'|'venue'|'hold_breakdown'|'hold_count'|'date_range'>;
}

export interface ShowsAddStageRequest {
    id: string;
    show: Omit<Show, 'id'|'attendance'|'ticket_revenue'|'bar_revenue'|'other_revenue'|'total_expenses'|'total_revenue'|'net_profit'|'is_settled'|'settlement_date'|'team_name'|'created_by'|'created_at'|'updated_at'|'show_stages'|'show_performers'|'venue'|'hold_breakdown'|'hold_count'|'date_range'>;
}

export interface ShowsCreateRequest {
    showCreateUpdate: Omit<ShowCreateUpdate, 'id'>;
}

export interface ShowsDestroyRequest {
    id: string;
}

export interface ShowsListRequest {
    page?: number;
    team?: number;
}

export interface ShowsPartialUpdateRequest {
    id: string;
    patchedShowCreateUpdate?: Omit<PatchedShowCreateUpdate, 'id'>;
}

export interface ShowsRemovePerformerRequest {
    id: string;
}

export interface ShowsRetrieveRequest {
    id: string;
}

export interface ShowsUpdateRequest {
    id: string;
    showCreateUpdate: Omit<ShowCreateUpdate, 'id'>;
}

export interface ShowsUpdatePerformerRequest {
    id: string;
    patchedShow?: Omit<PatchedShow, 'id'|'attendance'|'ticket_revenue'|'bar_revenue'|'other_revenue'|'total_expenses'|'total_revenue'|'net_profit'|'is_settled'|'settlement_date'|'team_name'|'created_by'|'created_at'|'updated_at'|'show_stages'|'show_performers'|'venue'|'hold_breakdown'|'hold_count'|'date_range'>;
}

/**
 * 
 */
export class ShowsApi extends runtime.BaseAPI {

    /**
     * Add a performer to the show.
     */
    async showsAddPerformerRaw(requestParameters: ShowsAddPerformerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showsAddPerformer().'
            );
        }

        if (requestParameters['show'] == null) {
            throw new runtime.RequiredError(
                'show',
                'Required parameter "show" was null or undefined when calling showsAddPerformer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/{id}/add_performer/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShowToJSON(requestParameters['show']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Add a performer to the show.
     */
    async showsAddPerformer(requestParameters: ShowsAddPerformerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsAddPerformerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a stage to the show.
     */
    async showsAddStageRaw(requestParameters: ShowsAddStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showsAddStage().'
            );
        }

        if (requestParameters['show'] == null) {
            throw new runtime.RequiredError(
                'show',
                'Required parameter "show" was null or undefined when calling showsAddStage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/{id}/add_stage/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShowToJSON(requestParameters['show']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Add a stage to the show.
     */
    async showsAddStage(requestParameters: ShowsAddStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsAddStageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get shows filtered by performer.
     */
    async showsByPerformerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/by_performer/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Get shows filtered by performer.
     */
    async showsByPerformer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsByPerformerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get shows filtered by status.
     */
    async showsByStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/by_status/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Get shows filtered by status.
     */
    async showsByStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsByStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get shows filtered by venue.
     */
    async showsByVenueRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/by_venue/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Get shows filtered by venue.
     */
    async showsByVenue(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsByVenueRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get shows for calendar view with date range.
     */
    async showsCalendarRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/calendar/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Get shows for calendar view with date range.
     */
    async showsCalendar(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsCalendarRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a new show
     * Create show
     */
    async showsCreateRaw(requestParameters: ShowsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowCreateUpdate>> {
        if (requestParameters['showCreateUpdate'] == null) {
            throw new runtime.RequiredError(
                'showCreateUpdate',
                'Required parameter "showCreateUpdate" was null or undefined when calling showsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShowCreateUpdateToJSON(requestParameters['showCreateUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowCreateUpdateFromJSON(jsonValue));
    }

    /**
     * Create a new show
     * Create show
     */
    async showsCreate(requestParameters: ShowsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowCreateUpdate> {
        const response = await this.showsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a show
     * Delete show
     */
    async showsDestroyRaw(requestParameters: ShowsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a show
     * Delete show
     */
    async showsDestroy(requestParameters: ShowsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.showsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get all shows for the user\'s teams
     * List shows
     */
    async showsListRaw(requestParameters: ShowsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedShowListList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['team'] != null) {
            queryParameters['team'] = requestParameters['team'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedShowListListFromJSON(jsonValue));
    }

    /**
     * Get all shows for the user\'s teams
     * List shows
     */
    async showsList(requestParameters: ShowsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedShowListList> {
        const response = await this.showsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Partially update an existing show
     * Partially update show
     */
    async showsPartialUpdateRaw(requestParameters: ShowsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowCreateUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedShowCreateUpdateToJSON(requestParameters['patchedShowCreateUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowCreateUpdateFromJSON(jsonValue));
    }

    /**
     * Partially update an existing show
     * Partially update show
     */
    async showsPartialUpdate(requestParameters: ShowsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowCreateUpdate> {
        const response = await this.showsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a performer from the show.
     */
    async showsRemovePerformerRaw(requestParameters: ShowsRemovePerformerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showsRemovePerformer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/{id}/remove_performer/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a performer from the show.
     */
    async showsRemovePerformer(requestParameters: ShowsRemovePerformerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.showsRemovePerformerRaw(requestParameters, initOverrides);
    }

    /**
     * Get detailed information about a show
     * Get show details
     */
    async showsRetrieveRaw(requestParameters: ShowsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Get detailed information about a show
     * Get show details
     */
    async showsRetrieve(requestParameters: ShowsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get show statistics for the team.
     */
    async showsStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/statistics/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Get show statistics for the team.
     */
    async showsStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get upcoming shows (show_date >= today).
     */
    async showsUpcomingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/upcoming/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Get upcoming shows (show_date >= today).
     */
    async showsUpcoming(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsUpcomingRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update an existing show
     * Update show
     */
    async showsUpdateRaw(requestParameters: ShowsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowCreateUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showsUpdate().'
            );
        }

        if (requestParameters['showCreateUpdate'] == null) {
            throw new runtime.RequiredError(
                'showCreateUpdate',
                'Required parameter "showCreateUpdate" was null or undefined when calling showsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ShowCreateUpdateToJSON(requestParameters['showCreateUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowCreateUpdateFromJSON(jsonValue));
    }

    /**
     * Update an existing show
     * Update show
     */
    async showsUpdate(requestParameters: ShowsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowCreateUpdate> {
        const response = await this.showsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a performer\'s details for the show.
     */
    async showsUpdatePerformerRaw(requestParameters: ShowsUpdatePerformerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Show>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showsUpdatePerformer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/shows/{id}/update_performer/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedShowToJSON(requestParameters['patchedShow']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowFromJSON(jsonValue));
    }

    /**
     * Update a performer\'s details for the show.
     */
    async showsUpdatePerformer(requestParameters: ShowsUpdatePerformerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Show> {
        const response = await this.showsUpdatePerformerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
